import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import React, { useState } from "react";

import * as styles from "./permissionelement.module.scss";
import PermissionSidePanel from "./PermissionSidePanel";
import PermissionPanelContent from "./PermissionPanelContent";
import { Toggle } from "cprime-foundational-components";

const PermissionElement: React.FC<any> = ({
  setActiveCard,
  index,
  label,
  isActive,
  isAvailable = false,
  isEditable,
  isDeletable,
  setPermissionUpdate,
  deletePermissionConfirm,
  permission,
  getPermission,
  canDelete,
  onStatusChange,
  isEditAllow,
}) => {
  const scssClass = styles as any;
  const [openDetailsSidePanel, setOpenDetailsSidePanel] = useState(false);
  const [openEditSidePanel, setOpenEditSidePanel] = useState<boolean>(false);
  const [toggle, setToggle] = useState({ isAvailable });

  const handlePermissionDetail = () => {
    setOpenDetailsSidePanel(!openDetailsSidePanel);
  };
  const handleDelete = () => {
    deletePermissionConfirm(permission);
  };

  const formatDate = (timestamp: any) => {
    const date = new Date(timestamp);

    // Extract necessary components
    const month = String(date?.getMonth() + 1)?.padStart(2, "0"); // Months are zero-indexed
    const day = String(date?.getDate())?.padStart(2, "0");
    const year = date?.getFullYear();
    const hours = String(date?.getHours() % 12 || 12)?.padStart(2, "0"); // Handle 12-hour format
    const minutes = String(date?.getMinutes())?.padStart(2, "0");
    const ampm = date?.getHours() >= 12 ? "PM" : "AM";

    // Format the date and time string
    const formattedDate = `${month}/${day}/${year} at ${hours}:${minutes} ${ampm}`;
    return formattedDate;
  };

  const handleStatusChange = () => {
    const newStatus = !toggle?.isAvailable;
    setToggle({ ...toggle, isAvailable: newStatus });
    if (setPermissionUpdate) {
      setPermissionUpdate(permission, newStatus);
    }
    if (onStatusChange) {
      onStatusChange(permission.permission_id, newStatus);
    }
  };
  const draggable = !openEditSidePanel && isActive && isEditAllow;

  return (
    <div
      draggable={draggable}
      onDragStart={() => setActiveCard(index)}
      onDragEnd={() => setActiveCard(null)}
      key={permission?.permission_id}
      data-testid={permission?.permission_id}
    >
      <div className={scssClass?.PermissionElement}>
        <div className={scssClass?.elementdatacontainer}>
          {isActive && (
            <DragIndicatorIcon
              fontSize="small"
              className={scssClass["draggable-card-css"]}
              data-testid={`drag-${permission?.permission_id}`}
            />
          )}

          <div className={scssClass?.Permissiondata}>
            <div className={scssClass?.Permissionheader}>
              <div
                className={scssClass?.Permissiontext}
                onClick={handlePermissionDetail}
                data-testid={"PermissionName"}
                role="button"
                tabIndex={0}
              >
                {label}
              </div>
              {isEditAllow && isEditable && (
                <EditOutlinedIcon
                  fontSize="small"
                  className={scssClass?.PermissionElementButton}
                  onClick={() => setOpenEditSidePanel(!openEditSidePanel)}
                  data-testid={`edit-${permission?.permission_id}`}
                />
              )}
            </div>
            <div
              className={scssClass?.createdText}
              data-testid={"PermissionDetails"}
            >
              {/* {`Rank ${permission?.rank || ""} | `} */}
              {permission?.app_name
                ? `${permission?.app_name || ""} | `
                : isAvailable
                  ? `Rank ${index + 1 || ""} | `
                  : null}
              {permission?.description ? `${permission?.description} | ` : ""}
              Created On{" "}
              {permission?.added_on || formatDate(permission?.created_on)}
              {/* {tooltipRegions ? (
                <Tooltip
                  title={
                    <div data-testid={"tooltipRegionsValue"}>
                      {tooltipRegions}
                    </div>
                  }
                  disabled={false}
                  placement="top"
                  data-testid={"tooltipRegions"}
                >
                  <span data-testid={"regions"}>{displayRegions}</span>
                </Tooltip>
              ) : (
                <span data-testid={"regions"}>{displayRegions}</span>
              )} */}
            </div>
          </div>
        </div>
        <div className={scssClass?.elementbuttoncontainer}>
          {isDeletable ? (
            <DeleteOutlinedIcon
              className={
                canDelete
                  ? scssClass?.PermissionElementButton
                  : scssClass?.PermissionElementButtonDisabled
              }
              onClick={handleDelete}
              data-testid={`delete-${permission?.permission_id}`}
            />
          ) : (
            <div style={{ width: "23.9974px" }}></div>
          )}
          <div
            style={{
              marginLeft: "8px",
              marginTop: "3px",
              cursor: "pointer",
            }}
          >
            <Toggle
              checked={toggle?.isAvailable}
              sx={{
                overflow: "visible",
                marginBottom: "4px",
                "& .MuiSwitch-thumb": {
                  marginTop: "4px",
                },
              }}
              disabled={!isEditAllow}
              size="small"
              data-testid={`set-status-${permission?.permission_id}`}
              onChange={handleStatusChange}
            />
          </div>
        </div>
      </div>
      {openEditSidePanel && (
        <PermissionSidePanel
          isEdit={true}
          permission_id={permission?.permission_id}
          setPermissionUpdate={setPermissionUpdate}
          permission={permission}
          onClose={() => setOpenEditSidePanel(false)}
          isAvailable={isAvailable}
          getPermission={getPermission}
          BodyComponent={
            <PermissionPanelContent
              isEdit={true}
              selectedPermission={{
                permission_id: permission?.permission_id,
                description: permission?.description,
                specifyPermissionType: permission?.permission_name,
                is_custom: permission?.is_custom,
              }}
            />
          }
        />
      )}
    </div>
  );
};

export default PermissionElement;
